import { matchPath } from 'react-router';
import { REHYDRATE } from 'redux-persist';
import { PayloadAction } from '@reduxjs/toolkit';

export const waitForConnectionEvent = (signal: AbortSignal) => new Promise((resolve) => {
  const onlineHandler = () => resolve(true);
  const offlineHandler = () => resolve(false);

  window.addEventListener('online', onlineHandler, { once: true });
  window.addEventListener('offline', offlineHandler, { once: true });

  signal.addEventListener('abort', () => {
    window.removeEventListener('online', onlineHandler);
    window.removeEventListener('offline', offlineHandler);
    resolve(true);
  });
});

export const isRehydrateOnHome = (action: PayloadAction) => {
  const isHomeLocation = matchPath('/', window.location?.pathname ?? '');
  return action.type === REHYDRATE && Boolean(isHomeLocation);
};
